<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <!-- <v-card-title class="headline">
              {{ $t('custom.teletype_messages') }}
            </v-card-title> -->
            <v-card-text>
              <teletype-chat ref="teletypeChat" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TeletypeChat from '@/components/dashboard/clients/TeletypeChat.vue';

export default {
  components: {
    TeletypeChat
  },
  data() {
    return {};
  },
  created() {
    this.setTitle();
    // Очищаем все предыдущие подписки на TeletypeDialog при создании страницы
    this.clearAllTeletypeDialogSubscriptions();
  },
  mounted() {
    // При монтировании страницы также сбрасываем активный диалог
    if (this.$refs.teletypeChat) {
      this.$refs.teletypeChat.resetActiveDialog();
    }
  },
  beforeDestroy() {
    // Очищаем все подписки при уничтожении компонента
    this.clearAllTeletypeDialogSubscriptions();
  },
  methods: {
    setTitle() {
      document.title = this.$t('teletype.teletype_messages') + ' | ' + this.$t('custom.app_name');
    },
    clearAllTeletypeDialogSubscriptions() {
      if (this.$cable && this.$cable.subscriptions && this.$cable.subscriptions.subscriptions) {
        const teletypeDialogSubs = this.$cable.subscriptions.subscriptions.filter(
          s => s.identifier.includes(`"channel":"TeletypeDialog"`)
        );

        teletypeDialogSubs.forEach(sub => {
          try {
            const subData = JSON.parse(sub.identifier);
            this.$cable.unsubscribe({
              channel: "TeletypeDialog",
              room: subData.room
            });
            console.log("Unsubscribed from TeletypeDialog:", subData.room);
          } catch (e) {
            console.error("Error parsing subscription identifier:", e);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
/* Дополнительные стили для страницы */
</style>
